<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
      <div v-if="data.length > 0">
          <b-list-group flush class="mt-1">
              <b-list-group-item class="flex-column align-items-start" v-for="item in data" :key="item.id">
                  <div v-b-toggle.collapse-a="String(item.id)" class="d-flex w-100 justify-content-between">
                      <h6 class="mb-1">{{item.title}}</h6>
                      <small class="badge badge-info" style="line-height: 1.4">{{item.permissions.length}} / {{item.permissions.filter(i => i.status).length}}</small>
                  </div>
                  <b-collapse :id="String(item.id)" class="border-top mb-2 mt-2">
                      <div class="row mb-2 mt-2" v-for="permission in item.permissions" :key="permission.id">
                          <div class="col-md-6">
                              <div>{{permission.title}} <span class="badge badge-pill badge-light">{{permission.key}}</span></div>
                              <div><small class="text-info">{{permission.description}}</small></div>
                          </div>
                          <div class="col-md-6 align-self-center">
                              <div v-if="calculated[permission.key].inherited">
                                  <div class="clearfix">
                                      <div class="float-left mr-3">
                                          <span class="badge badge-success">Granted: {{calculated[permission.key].inherited.title}}</span>
                                      </div>
                                      <div class="float-left">
                                          <b-form-checkbox v-model="calculated[permission.key].status" :id="permission.key" :name="permission.key" :value="false" :unchecked-value="true">
                                              Forbid
                                          </b-form-checkbox>
                                      </div>
                                  </div>
                              </div>
                              <div v-else>
                                  <b-form-radio-group v-model="calculated[permission.key].status" :name="permission.key" :options="[{text: 'None', value: null}, {text: 'Forbid', value: false}, {text: 'Granted', value: true}]"></b-form-radio-group>
                              </div>
                          </div>
                      </div>
                  </b-collapse>

              </b-list-group-item>
          </b-list-group>
          <div class="m-3 clearfix">
              <b-button class="float-right" @click="() => onSave()" :disabled="loading" variant="primary">Save</b-button>
          </div>
      </div>
      <div class="text-center m-3" v-else>
        <h5 class="card-title">Search Result</h5>
        <p class="card-text">No Data</p>
      </div>

    </div>
  </div>
</template>

<script>
import GetPermissions from '../../../../store/actions/getPermissions';
import UpdateUserPermission from '../../../../store/actions/updateUserPermission';
import GetUser from '../../../../store/actions/getUser';
import ShowError from "../../../../helpers/showError";
import ContentLoader from '../../../../components/ContentLoader';

export default {
  name: 'UserPermissions',
  components: {
    loader: ContentLoader,
  },
  data(){
    return {
      loading: false,
      data: [],
      permissions: {},
      calculated: {}
    }
  },
  created() {
    this.getPermissions();
  },
  methods: {
    async onSave(){
      try{
        this.loading = true;
        const payload = {
          extraPermissions: Object.values(this.calculated).map(calculated => {
            if(!calculated.inherited && calculated.status) {
              return {id: calculated.id, key: calculated.key}
            }
          }).filter(i => i),
          forbidPermissions: Object.values(this.calculated).map(calculated => {
            if(calculated.status === false) {
              return {id: calculated.id, key: calculated.key}
            }
          }).filter(i => i)
        };

        await UpdateUserPermission(this.$route.params.id, payload);
        this.getPermissions();
      } catch (e) {
        ShowError(this, e);
      }
      finally {
        this.loading = false;
      }
    },
    async getPermissions(){
      try {
        this.loading = true;
        const user = await GetUser(this.$route.params.id);
        const permissions = await GetPermissions();
        this.data = permissions;
        let calculated = {};
        permissions.forEach(permGroup => {
          permGroup.permissions.forEach(perm => {
            const groups = this.$store.state.groups.filter(state => user.groups.find(ug => state.id === ug.id));
            const findG = groups.find(g => g.permissions.find(p => p.key === perm.key));
            if(findG) {
              perm.status = true;
              perm.inherited = {id: findG.id, title: findG.title};
            } else {
              perm.status = null;
              perm.inherited = false;
            }

            user.extraPermissions.forEach(extra => {
              if(extra.id === perm.id) {
                perm.status = true;
              }
            });

            user.forbidPermissions.forEach(forbid => {
              if(forbid.id === perm.id) {
                perm.status = false;
              }
            });

            calculated[perm.key] = perm;
          });
        });


        this.calculated = calculated;
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
